function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useMemo } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { editSiderMenus, itFilter, flatten, checkRedirect } from './editSiderMenus';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function configToRoute(v) {
  var RouteCom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Route;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: v.map(function (v) {
      var _v$children;

      var children = configToRoute((_v$children = v.children) !== null && _v$children !== void 0 ? _v$children : []);

      if (checkRedirect(v)) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Redirect, {
            to: v.redirect
          }), children]
        });
      }

      var key = v.path + v.opt.title;
      var C = v.Com;
      var routeConfig = v.opt.routeConfig;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(RouteCom, _objectSpread(_objectSpread({
          exact: true,
          path: v.path
        }, routeConfig), {}, {
          children: /*#__PURE__*/_jsx(C, {})
        }), key), children]
      });
    })
  });
}

export var useRouterCom = function useRouterCom(routeConfig) {
  var RouteCom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Route;

  var _useMemo = useMemo(function () {
    var siderConf = itFilter(routeConfig, function (v) {
      return !checkRedirect(v) && v.opt.sider;
    });
    var siderRoutes = configToRoute(siderConf, RouteCom);
    var siderRoutePath = flatten(siderConf, function (v) {
      return v.opt.path;
    });
    return {
      siderRoutePath: siderRoutePath,
      siderRoutes: siderRoutes
    };
  }, [RouteCom, routeConfig]),
      siderRoutes = _useMemo.siderRoutes,
      siderRoutePath = _useMemo.siderRoutePath;

  var routes = useMemo(function () {
    return configToRoute(itFilter(routeConfig, function (v) {
      return checkRedirect(v) || !v.opt.sider;
    }), RouteCom);
  }, [RouteCom, routeConfig]);
  var menus = useMemo(function () {
    return editSiderMenus(routeConfig);
  }, [routeConfig]);
  return {
    routes: routes,
    siderRoutePath: siderRoutePath,
    siderRoutes: siderRoutes,
    menus: menus
  };
};
//# sourceMappingURL=es/generateRoute.js.map